module.exports = __webpack_public_path__ + "static/img/how-it-work-inclusion-img.6067364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-work-inclusion-img.jpg
// module id = QnXS
// module chunks = 0